// eslint-disable-next-line import/prefer-default-export
export enum ESidebarType {
  DEFAULT = 'default',
  PROFILE = 'profile',
  TOPICS = 'topics',
  CONSULTANT = 'consultant',
}
